import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Optional, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { I18nValue } from '@gspwidget/util';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';


/** 支持的语言 */
export class Lang {
  constructor (
    public code: string,
    public name: string
  ) {}
}

export class I18N_INPUT_CONFIG {
  langs: Promise<Lang[]> | Lang[]
}

/**
 * 当前控件返回的 value，是一个新引用吗？
 * 还是原引用，更改了内部值?
 * 本来用了前者。现在打算改为后面的试试，还没改。
 */
@Component({
  selector: 'lib-i18n-input',
  templateUrl: './i18n-input.component.html',
  styleUrls: ['./i18n-input.component.scss']
})
export class I18nInputComponent implements OnChanges {

  @Input() placeholder: string
  /** TODO: 会变，待处理 */
  @Input() value: I18nValue | string
  @Input() required = false
  @Input() maxLength = 20
  /** 起的啥名啊. true 是失焦触发值变化, false 是变化触发值变化 */
  @Input() valueChangeOnBlur = true
  @Output() valueChange = new EventEmitter<I18nValue>()
  @ViewChild('mainInput') mainInput: NgModel
  // 这个给外面看
  valid: boolean

  innerValue: I18nValue = new I18nValue()
  tempValue: I18nValue = new I18nValue()
  curLang: string
  showingDropdown = false

  // langs: Lang[] = [{
  //   code: 'zh-CHS',
  //   name: 'chinese'
  // }, {
  //   code: 'en',
  //   name: 'english'
  // }]
  langs: Lang[] = []
  orderedLangs

  constructor (
    public translate: TranslateService,
    public cd: ChangeDetectorRef,
    @Optional() public config: I18N_INPUT_CONFIG
  ) {
    this.curLang = this.translate.currentLang
    // 监听语言改变后设置
    this.translate.onLangChange.subscribe((e: LangChangeEvent) => this.setMainLang(e.lang))
    // 从 config 中获取当前支持语言列表
    if (config && config.langs) {
      if (config.langs['then']) {
        (config.langs as Promise<Lang[]>).then(langs => this.setLangs(langs))
      } else {
        this.setLangs(config.langs as Lang[])
      }
    }
  }

  ngAfterViewInit () {
    this.mainInput.statusChanges.subscribe(status => {
      this.valid = status === 'VALID'
    })
  }
  setLangs (langs: Lang[]) {
    this.langs = langs
    this.setMainLang(this.translate.currentLang)
  }
  /** 改变顺序。待改进，因为只有调了它可以更新 html */
  setMainLang (lang: string) {
    this.curLang = lang
    const i = this.langs.findIndex(l => l.code === lang)
    this.orderedLangs = this.langs.slice()
    moveItemInArray(this.orderedLangs, i, 0)
  }

  ngOnChanges (changes: SimpleChanges): void {
    if (changes.value.currentValue !== changes.value.previousValue) {
      const value = (typeof this.value === 'string' || !this.value)
        ? { [this.translate.currentLang]: this.value }
        : this.value
      this.innerValue = { ...value }
      this.tempValue = { ...value }
    }
  }
  handleInputChange () {
    this.valueChange.emit(this.innerValue)
    this.tempValue = { ...this.innerValue }
  }
  handleConfirm () {
    this.innerValue = { ...this.tempValue }
    this.valueChange.emit(this.innerValue)
    this.showingDropdown = false
  }
  handleCancel () {
    this.tempValue = { ...this.innerValue }
    this.showingDropdown = false
  }

}
